(() => {
  function update(root, cart) {
    root.querySelectorAll('[data-cart-rewards]').forEach(el => {
      const relay = Number(el.dataset.relayThreshold || 3900);
      const home = Number(el.dataset.homeThreshold || 5900);
      const half = Number(el.dataset.halfQuantity || 7);
      const total = Number(cart.total_price || 0);
      // The builder counts quantities within the selected format, including repeat flavours.
      const quantities = {};
      (cart.items || []).forEach(item => {
        if (/pack-decouverte/.test(item.handle || item.url || '')) return;
        const title = item.variant_title || item.title || '';
        const format = /100\s*g/i.test(title) ? '100g' : /infus|dosette|sachet.*individ/i.test(title) ? 'infusettes' : title;
        quantities[format] = (quantities[format] || 0) + Number(item.quantity || 0);
      });
      const quantity = Math.max(0, ...Object.values(quantities));
      const relayPosition = home > 0 ? Math.max(18, Math.min(66, 74 * relay / home)) : 48;
      const positions = { relay: relayPosition, home: 74, half: 100 };
      const unlocked = { relay: total >= relay, home: total >= home, half: quantity >= half };
      el.querySelectorAll('[data-reward-level], [data-reward-marker]').forEach(node => {
        const key = node.dataset.rewardLevel || node.dataset.rewardMarker;
        node.style.setProperty('--reward-position', `${positions[key]}%`);
        node.classList.toggle('is-unlocked', unlocked[key]);
      });
      let fill;
      if (total < relay) fill = relayPosition * total / Math.max(relay, 1);
      else if (total < home) fill = relayPosition + (74 - relayPosition) * (total - relay) / Math.max(home - relay, 1);
      else if (quantity < half) fill = 74 + 26 * Math.max(0, Math.min(1, (quantity - 1) / Math.max(half - 1, 1)));
      else fill = 100;
      el.querySelector('[data-cart-rewards-fill]').style.width = `${Math.max(0, Math.min(100, fill))}%`;
      const money = cents => new Intl.NumberFormat('fr-FR', {style:'currency', currency:el.dataset.currency || 'EUR'}).format(cents / 100);
      let message;
      if (total < relay) message = `Encore ${money(relay - total)} pour la livraison Point Relais offerte`;
      else if (total < home) message = `Point Relais offert ✓ · Encore ${money(home - total)} pour la livraison à domicile offerte`;
      else if (quantity < half) message = `Livraison à domicile offerte ✓ · ${half - quantity === 1 ? `Plus qu’une unité ! Ajoute ta ${half}e et profite de -50 % sur celle-ci.` : `Encore ${half - quantity} unités pour débloquer -50 % sur la ${half}e.`}`;
      else message = `Tous tes avantages sont débloqués 🎉 · Ta ${half}e unité est à -50 %.`;
      el.querySelector('[data-cart-reward-message]').textContent = message;
    });
  }
  function init() {
    document.querySelectorAll('[data-cart-rewards-state]').forEach(node => {
      try { update(node.parentElement, JSON.parse(node.textContent)); } catch (error) { console.error('INFUZZE : progression du panier', error); }
    });
  }
  window.InfuzzeCartRewards = { update };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
